import { keyframes } from '@emotion/react';

export const themeVariables = {
  background: {
    purple100: `linear-gradient(
      180deg,
      rgba(139, 92, 246, 0.01) 0%,
      rgba(255, 255, 255, 0) 100%
    ),
    rgba(27, 27, 30, 0.1)`,
    purple200: `linear-gradient(
      180deg,
      rgba(139, 92, 246, 0.03) 0%,
      rgba(255, 255, 255, 0) 100%
    ),
    rgba(27, 27, 30, 1)`,
    solid: 'rgba(27, 27, 30, 0.9)',
    modal: '#08040f',
    homeCards: `radial-gradient(
      50% 50% at 20% 20%,
      rgba(125, 70, 250, 0.18) 0%,
      rgba(69, 44, 126, 0) 100%
    ),
    linear-gradient(
      180deg,
      rgba(139, 92, 246, 0.03),
      rgba(255, 255, 255, 0)
    ),
    rgba(27, 27, 30, 0.9)`,
    topPortfolios: `radial-gradient(
      50% 50% at 50% 50%,
      rgba(125, 70, 250, 0.12) 0%,
      rgba(69, 44, 126, 0) 100%
    ),
    linear-gradient(
      180deg,
      rgba(139, 92, 246, 0.03),
      rgba(255, 255, 255, 0)
    ),
    rgba(27, 27, 30, 0.9)`,
    join: `radial-gradient(
      50% 50% at 50% 50%,
      rgba(125, 70, 250, 0.15) 47%,
      rgba(69, 44, 126, 0) 100%
    ),
    linear-gradient(
      180deg,
      rgba(139, 92, 246, 0.03),
      rgba(255, 255, 255, 0)
    ),
    rgba(27, 27, 30, 0.9)`,
    middleBlub: `radial-gradient(
      50% 50% at 50% 50%,
      rgba(125, 70, 250, 0.12) 63.5%,
      rgba(69, 44, 126, 0) 100%
    ),
    linear-gradient(
      180deg,
      rgba(139, 92, 246, 0.03),
      rgba(255, 255, 255, 0)
    ),
    rgba(27, 27, 30, 0.9)`,
    card: `linear-gradient(
      180deg,
      rgba(139, 92, 246, 0.03),
      rgba(255, 255, 255, 0)
    ),
    rgba(27, 27, 30, 0.9)`,
    tableModals: `linear-gradient(
      180deg,
      rgba(139, 92, 246, 0.03) 0%,
      rgba(255, 255, 255, 0) 100%
    ),
    rgba(27, 27, 30, 0.9)`,
  },
  gradient: {
    start: 'rgba(139, 92, 246, 0.03)',
    end: 'rgba(255, 255, 255, 0)',
    angle: '180deg',
    button: `linear-gradient(
      87deg,
      rgba(76, 29, 149, 0.2) 0%,
      rgba(124, 58, 237, 0.2) 100%
    )`,
    button100: `linear-gradient(
      87deg,
      rgba(77, 29, 149, 0.794) 0%,
      rgba(124, 58, 237, 0.2) 100%
    )`,
    table: `linear-gradient(
      87deg,
      rgba(76, 29, 149, 0.05) 0%,
      rgba(124, 58, 237, 0.05) 100%
    )`,
  },
  purple: {
    divider: '#3a2e5c',
    subtext: '#a78bfa',
    button100: '#8b5cf6',
    button200: '#8a5cf6c7',
    metera: '#8b5cf6',
    metera100: '#c4b5fd',
    metera200: '#8b5cf669',
    metera300: 'rgba(76, 29, 149, 0.4)',
  },
  distribution: {
    one: '#4c1d95',
    two: '#6d28d9',
    three: '#8b5cf6',
    four: '#a78bfa',
    five: '#c4b5fd',
  },
  neutral: {
    1000: 'rgba(23, 23, 23, 1)',
    900: 'rgba(23, 23, 23, 1)',
    800: '#262626',
    600: '#525252',
    500: '#737373',
    400: '#a3a3a3',
    300: '#d4d4d4',
    200: '#e5e5e5',
  },
  cards: {
    stroke: 'rgba(192, 166, 253, 0.25)',
    stroke2: 'rgba(192, 166, 253, 0.2)',
    background: '#ef4444',
  },
  error: {
    error500: '#ef4444',
  },
  success: {
    success500: '#22c55e',
  },
  offWhite: {
    offWhite400: '#fafaf4',
  },
  primary: {
    primary50: '#f5f3ff',
  },
  header: {
    table: '#2c2658',
  },
  circle: {
    fill: '#83d2ff',
  },
  backgrounds: {
    one: '#3b2b67',
    two: '#270e45',
  },
  animatedBorder: {
    initialValue: '0turn',
    animationTo: '1turn',
    bgSpin: keyframes`
      to {
        --animated-border: 1turn;
      }
    `,
  },
  blinkAnimation: keyframes`
    {
      0%,
      100% {
        transform: scale(1);
      }
      50% {
        transform: scale(0.7);
      }
    }
  `,
  opacityAnimation: keyframes`
    {
      0%,
      100% {
        opacity: 1;
      }
      50% {
        opacity: 0.6;
      }
    }
  `,
};
